import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { defaultText } from "../content/defaults";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({ overrides: {}, t: defaultText, refresh: () => {} });

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content`);
      setOverrides(res.data?.overrides || {});
    } catch {
      setOverrides({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => {
    const t = (key) => {
      const v = overrides[key];
      return v && v.trim() ? v : defaultText(key);
    };
    return { overrides, t, refresh };
  }, [overrides, refresh]);

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
